import React, {Component} from 'react';
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";
import {Button, InputGroupAddon, Tooltip} from "reactstrap";
import classnames from "classnames";
import InputNumber from "components/InputNumber";
import { connect } from 'react-redux';
import {setPlanRestrictionsModals} from "reducers/planRestrictionsModals/actions";
import QuestionSettingAvailable from "components/PlanRestrictionsModals/modals/QuestionSettingAvailable";

class RandColumns extends Component {

  constructor(props) {
    super(props);
    this.state = {
      question: {
        randColumns: props.question.randColumns,
      },
      tooltip: false,
    };

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  toggleTooltip() {
    this.setState({
      tooltip: !this.state.tooltip
    });
  }

  onChange(value){
    if (this.props.disabled) {
      this.props.setPlanRestrictionsModals(QuestionSettingAvailable.getName());
      return;
    }

    if(!value || value < 0){
      value = 0;
    }

    this.setState({
      question: {
        ...this.state.question,
        randColumns: value
      }
    },
      () => this.props.handleUpdate(this.state.question)
    );
  }

  render() {
    let { question, tooltip } = this.state;

    return (
      <div
        id={"randColumns-" + this.props.question.id}
        className={classnames({
          "min-w-0 float-left mr-1 mb-1": true,
          "w-auto": question.randColumns === 0,
          "w-100 w-lg-auto input-group": question.randColumns > 0
        })}
      >
        <InputGroupAddon addonType="prepend">
          <Button
            className={classnames({
              "btn-icon": true,
              "active": question.randColumns > 0,
              "disabled": this.props.disabled
            })}
            color="secondary"
            onClick={() => {
              if(question.randColumns === 0){
                this.onChange(1)
              }else{
                this.onChange(0)
              }
            }}
          >
            <i className="fak fa-rotate-vertical" />
            <Tooltip
              delay={0}
              placement="top"
              isOpen={tooltip}
              target={"randColumns-" + this.props.question.id}
              toggle={() => this.toggleTooltip()}
            >
              <FormattedMessage id="question.settings.randColumns.button.tooltip"/>
            </Tooltip>
          </Button>
        </InputGroupAddon>
        {question.randColumns > 0 && <InputNumber value={question.randColumns} min={0} max={this.props.question.columns.length} onChange={(value) => this.onChange(value)} className={this.props.disabled ? "not-active" : ""}/>}
      </div>
    )
  }
}

RandColumns.propTypes = {
  question: PropTypes.shape({
    id: PropTypes.number.isRequired,
    randColumns: PropTypes.number.isRequired,
  }).isRequired,
  handleUpdate: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};

export default connect(null, {setPlanRestrictionsModals})(RandColumns);
